<template>
  <div class="sof-wrapper">
    <div class="sof">
      <div class="sof-head-wrapper">
        <div class="sof-head">
          <div class="bold-600 fs-24 t-fs-20 mb-4">
            Check wallet address
          </div>
          <SourceSearchBox
            ref="SourceSearchBoxRef"
            @data-result="setDataSearchResult"
          />
        </div>
      </div>
      <div class="sof-main-content-wrapper">
        <div class="sof-main-content">
          <div
            v-show="isReportHistoryDataPresent"
            key="reportHistory"
            class="flex column"
          >
            <div class="sof-table__title">
              Report History
            </div>
            <ReportHistoryTable
              :rows-per-page="10"
              @isHistoryPresent="isHistoryPresent"
            />
          </div>

          <div
            v-if="!isB2bUser"
            key="ReportExamples"
            class="flex column"
          >
            <div class="sof-table__title">
              Report Examples
            </div>

            <ReportExamples />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapState, mapMutations, mapGetters } from 'vuex'
//Components
import SourceSearchBox from './components/SourceSearchBox.vue'
import ReportHistoryTable from '@/pages/your-reports/components/ReportHistoryTable'
import ReportExamples from '@/pages/your-reports/components/ReportExamples'

export default {
  name: 'SourceOfFunds',
  components: {
    SourceSearchBox,
    ReportHistoryTable,
    ReportExamples,
  },
  data() {
    return {
      whatCheckModal: false,
      isResultSeted: false,
      dataSearchResult: [],
      activeValue: '',
      isReportHistoryDataPresent: false,
    }
  },
  computed: {
    ...mapState('analytics', ['coinType']),
    ...mapGetters('user', ['isB2bUser']),
  },
  methods: {
    ...mapMutations({
      SET_REDIRECT_PAYMENT_MODAL: 'payment/SET_REDIRECT_PAYMENT_MODAL',
    }),
    setDataSearchResult(data) {
      this.isResultSeted = Boolean(data.length)
      this.dataSearchResult = data
    },
    updateDataSearchResultByKey(e) {
      this.dataSearchResult = this.dataSearchResult.map(item => {
        if (e.reportPartName == item.reportPartName) {
          return { ...e }
        } else {
          return { ...item }
        }
      })
    },
    updateSearchData({ value, recalc }) {
      this.$refs.SourceSearchBoxRef.searchData(value, recalc)
    },
    isHistoryPresent(flag) {
      this.isReportHistoryDataPresent = flag
    },
  },
}
</script>

<style>
:root {
  --sof-header-height: 190px;
}
.sof-wrapper {
  display: flex;
  justify-content: center;
  background-color: var(--white);
  padding-top: var(--header-height);
  font-family: 'Montserrat', sans-serif;
}

.sof {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: var(--main-content-height);
}

.sof-head-wrapper {
  display: flex;
  justify-content: center;
  width: var(--full-width);
  background-color: var(--white);
  box-shadow: 0px 1px 4px 0px rgba(9, 21, 64, 0.08);
  position: sticky;
  top: var(--header-height);
  z-index: 11;
}

.sof-head {
  width: var(--main-content-width);
  max-width: var(--main-content-max-width);
  padding-top: 24px;
  padding-bottom: 24px;
}

.sof-main-content-wrapper {
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  background: var(--Background-S0, #F5F5F7);
  padding-top: 50px;
  padding-bottom: 70px;
}
.sof-main-content-wrapper .sof-check-wrapper {
  padding-bottom: 96px;
}

.sof-main-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  width: var(--main-content-width);
  max-width: var(--main-content-max-width);
}

.sof-table__title {
  color: var(--Basic-900, #091540);
  font-size: var(--Size-2XL, 20px);
  font-weight: 700;
  line-height: var(--Line-Height-3XL, 28px);
  margin-bottom: 24px;
}

.sof-main-content tr {
  transition: background-color 0.3s ease !important;
}
.sof-main-content tr:hover {
  background: var(--Background-S0, #F5F5F7);
}

@media (max-width: 1024px) {
  .sof-main-content-wrapper {
    padding-bottom: 110px;
  }
}

@media (max-width: 799px) {
  .sof-head-wrapper {
    top: 0;
    padding-left: 16px;
    padding-right: 16px;
    z-index: 102;
  }
  .sof-head {
    width: 100%;
    padding-bottom: 24px;
  }
}
</style>
